module.exports = __webpack_public_path__ + "img/roulet.4509546b.png";